// Whether a puzzle is on the board, from the `puzzles` API: while one is,
// the bar yields its row to the puzzle's banner (`review.header.puzzle`).
// The API is optional: without the puzzles plugin the bar always shows.
import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { PUZZLES_API, type PuzzleRun, type Puzzles } from '@chess/api-puzzles';

export function usePuzzleRun(app: PiletApi): PuzzleRun | undefined {
  const [puzzles, setPuzzles] = React.useState<Puzzles | undefined>(() => app.tryGetApi<Puzzles>(PUZZLES_API));
  React.useEffect(() => {
    if (puzzles) return;
    let alive = true;
    void app.getApi<Puzzles>(PUZZLES_API).then((p) => alive && setPuzzles(p));
    return () => {
      alive = false;
    };
  }, [app, puzzles]);
  const subscribe = React.useCallback((notify: () => void) => (puzzles ? puzzles.subscribe(notify) : () => undefined), [puzzles]);
  // The run is read as its ply, a value, so a render happens only when the puzzle changes.
  const read = () => puzzles?.current()?.ply;
  const ply = React.useSyncExternalStore(subscribe, read, read);
  return ply === undefined ? undefined : { ply };
}
